import { render, staticRenderFns } from "./control-element.vue?vue&type=template&id=a08e4d9c&"
import script from "./control-element.vue?vue&type=script&lang=js&"
export * from "./control-element.vue?vue&type=script&lang=js&"
import style0 from "./control-element.vue?vue&type=style&index=0&id=a08e4d9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports